import { render, staticRenderFns } from "./fold-btn.vue?vue&type=template&id=4cf666a9&scoped=true&"
import script from "./fold-btn.vue?vue&type=script&lang=ts&"
export * from "./fold-btn.vue?vue&type=script&lang=ts&"
import style0 from "./fold-btn.vue?vue&type=style&index=0&id=4cf666a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf666a9",
  null
  
)

export default component.exports